module.exports = __webpack_public_path__ + "img/sakib.904d24e3.jpg";